import { useNavigate } from 'react-router-dom'

import { Box, CardInfo, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type TerminatedEmployeesCardProps = {
  employeesCount: number
}

export const TerminatedEmployeesCard = ({ employeesCount }: TerminatedEmployeesCardProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <Box
      width="full"
      cursor="pointer"
      onClick={() => navigate(navigation.software.applications.terminatedEmployees.fullPath())}
    >
      <CardInfo>
        <Box justifyContent="spaceBetween" flexDirection="row" alignItems="center">
          <Text.Normal weight="medium" color="grey1000">
            {i18n.t('it_management.software_setups.dashboard.header.terminated_count', {
              count: employeesCount,
            })}
          </Text.Normal>
          <Icon.Medium icon="arrow-right" color="grey800" />
        </Box>
      </CardInfo>
    </Box>
  )
}
